import axios, { AxiosRequestConfig } from 'axios';
import Qs from 'qs';

/**
 * Base API URL to which to make requests.
 */
let API_BASE_URL: string = window.REACT_APP_API_BASE_URL;
axios.defaults.baseURL = API_BASE_URL;

export enum ContentTypes {
  Json = 'application/json',
  Plaintext = 'text/plain',
  FormData = 'multipart/form-data',
  Octet = 'application/octet-stream',
}

/**
 *
 * @param bearerToken
 * @param contentType
 * @returns
 */
const getAxiosRequestConfig = (
  bearerToken: string,
  params?: any,
  contentType: ContentTypes = ContentTypes.Json
): AxiosRequestConfig<any> => {
  return {
    paramsSerializer: (params) => {
      const serialized = Qs.stringify(params, {
        arrayFormat: 'indices',
        encode: false,
        allowDots: true,
      });
      return serialized;
    },
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': contentType,
    },
    params,
  };
};

export { API_BASE_URL, getAxiosRequestConfig };
